import type { ComponentType, SVGProps } from 'react';
import { Circle1Icon, Circle2Icon, Circle3Icon } from '@c2fo/liquidity/icons';

const APPLICATION_STEPS = [
  {
    title: 'Gather Business Details',
    description:
      'Get your business information ready, including your EIN and SSN, accounting software name (optional), and business bank account details.',
  },
  {
    title: 'Submit Your Application',
    description: 'Only financial decision makers should complete the application using this information.',
  },
  {
    title: 'Receive A Decision',
    description: 'Fundbox will evaluate your eligibility in as little as three minutes.',
  },
];

const STEP_ICONS: ComponentType<SVGProps<SVGSVGElement>>[] = [Circle1Icon, Circle2Icon, Circle3Icon];

const FundboxApplicationSteps = (): JSX.Element => (
  <div className="flex flex-col items-center space-y-6">
    <p className="text-3xl">Applying is simple and fast.</p>
    <p className="text-lg">Just follow these three steps</p>
    <div className="w-full rounded-2xl bg-white p-8 shadow-md">
      <div className="grid grid-cols-1 border-none md:grid-cols-3 [&>*:not(:last-child)]:border-b [&>*:not(:last-child)]:border-deepGray-500/[12%] [&>*:not(:last-child)]:pb-8 md:[&>*:not(:last-child)]:border-b-0 md:[&>*:not(:last-child)]:pb-0 md:[&>*:nth-child(1)]:border-r md:[&>*:nth-child(1)]:border-deepGray-500/[12%] md:[&>*:nth-child(2)]:border-r md:[&>*:nth-child(2)]:border-deepGray-500/[12%]">
        {APPLICATION_STEPS.map((step, index) => {
          const StepIcon = STEP_ICONS[index];

          return (
            <div key={step.title} className="flex flex-col items-center space-y-3 px-4 text-center md:px-6">
              {StepIcon ? <StepIcon className="h-12 w-12 fill-text-primary" aria-hidden /> : null}
              <p className="text-lg font-medium">{step.title}</p>
              <p className="text-base text-text-secondary">{step.description}</p>
            </div>
          );
        })}
      </div>
    </div>
  </div>
);

export default FundboxApplicationSteps;
